module.exports = __webpack_public_path__ + "media/images/logo-4040fc7adb3a1fd3899ffa844137c00c.svg";